import { Link } from "react-router-dom";
import type { Topic } from "@/types/content";

interface TopicCardProps {
  topic: Topic;
  variant?: "card" | "row";
}

export default function TopicCard({ topic, variant = "card" }: TopicCardProps) {
  if (variant === "row") {
    return (
      <Link
        to={`/detail/topic/${topic.id}`}
        className="group flex gap-4 rounded-lg border border-background-200 bg-background-50 p-3 transition-colors hover:border-primary-300 md:p-4"
      >
        <div className="h-20 w-28 shrink-0 overflow-hidden rounded-md bg-background-100 md:h-24 md:w-36">
          <img
            src={topic.cover}
            alt={`${topic.title} 话题配图`}
            title={`${topic.title} 网络话题 巨乳娱乐资讯网`}
            className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
        </div>
        <div className="flex min-w-0 flex-1 flex-col gap-1.5">
          <span className="w-fit rounded-full bg-secondary-100 px-2 py-0.5 text-xs text-secondary-900">
            {topic.tag}
          </span>
          <h3 className="line-clamp-2 text-sm font-medium text-foreground-950 group-hover:text-primary-600 md:text-base">
            {topic.title}
          </h3>
          <p className="line-clamp-2 text-xs leading-relaxed text-foreground-600">
            {topic.excerpt}
          </p>
          <span className="mt-auto text-xs text-foreground-400">
            {topic.date}
          </span>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={`/detail/topic/${topic.id}`}
      className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
    >
      <div className="w-full aspect-[8/5] overflow-hidden bg-background-100">
        <img
          src={topic.cover}
          alt={`${topic.title} 话题配图`}
          title={`${topic.title} 网络话题 巨乳娱乐资讯网`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
      </div>
      <div className="flex flex-1 flex-col gap-2 p-4">
        <span className="w-fit rounded-full bg-secondary-100 px-2 py-0.5 text-xs text-secondary-900">
          {topic.tag}
        </span>
        <h3 className="line-clamp-2 text-sm font-medium text-foreground-950 group-hover:text-primary-600 md:text-base">
          {topic.title}
        </h3>
        <p className="line-clamp-2 text-xs leading-relaxed text-foreground-600">
          {topic.excerpt}
        </p>
        <span className="mt-auto text-xs text-foreground-400">{topic.date}</span>
      </div>
    </Link>
  );
}